import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardContent, Divider, Typography, Button, Grid, Box, Chip } from '@mui/material';
import { LocationOn, Schedule, Business, Description } from '@mui/icons-material';
import axios from 'axios';
import Swal from 'sweetalert2';

const ViewCareerDetailPage = () => {
  const { id } = useParams(); // Access the `id` from the URL
  const [career, setCareer] = useState(null);

  useEffect(() => {
    const fetchCareerDetails = async () => {
      const token = localStorage.getItem('token');
      try {
        const response = await axios.get(`https://3wzg6m6x-5000.asse.devtunnels.ms/api/career/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCareer(response.data);
      } catch (error) {
        console.error('Error fetching career details:', error);
        Swal.fire('Error', 'Unable to fetch career details. Please try again later.', 'error');
      }
    };

    fetchCareerDetails();
  }, [id]);

  return (
    <Box sx={{ maxWidth: 900, margin: 'auto', paddingTop: 4 }}>
      <Card 
        sx={{ 
          borderRadius: '15px', 
          boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.1)', 
          padding: 3,
          backgroundColor: '#ffffff', // Change to white for contrast
          '&:hover': { boxShadow: '0px 12px 30px rgba(0, 0, 0, 0.2)' } // Hover effect
        }}
      >
        <CardContent>
          {career ? (
            <>
              {/* Career Title */}
              <Typography variant="h4" sx={{ fontWeight: 700, marginBottom: 2, color: '#222' }}>
                {career.title}
              </Typography>
              <Divider sx={{ marginBottom: 3 }} />

              {/* Details Section */}
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1" sx={{ fontWeight: 600, color: '#333' }}>
                    <LocationOn sx={{ fontSize: 20, verticalAlign: 'middle', marginRight: 1 }} />
                    Location:
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#555' }}>
                    {career.location}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1" sx={{ fontWeight: 600, color: '#333' }}>
                    <Schedule sx={{ fontSize: 20, verticalAlign: 'middle', marginRight: 1 }} />
                    Type:
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#555' }}>
                    {career.type}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1" sx={{ fontWeight: 600, color: '#333' }}>
                    <Schedule sx={{ fontSize: 20, verticalAlign: 'middle', marginRight: 1 }} />
                    Deadline:
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#555' }}>
                    {career.deadline}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1" sx={{ fontWeight: 600, color: '#333' }}>
                    <Business sx={{ fontSize: 20, verticalAlign: 'middle', marginRight: 1 }} />
                    Business Unit:
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#555' }}>
                    {career.bu_master?.name || 'No Business Unit'}
                  </Typography>
                </Grid>
              </Grid>

              {/* Description Section */}
              <Divider sx={{ marginTop: 3, marginBottom: 2 }} />
              <Typography variant="body1" sx={{ fontWeight: 600, color: '#333' }}>
                <Description sx={{ fontSize: 20, verticalAlign: 'middle', marginRight: 1 }} />
                Description:
              </Typography>
              <Typography variant="body2" sx={{ color: '#555', whiteSpace: 'pre-line', marginBottom: 2 }}>
                {career.description || 'No description available.'}
              </Typography>

              {/* Status Section */}
              <Chip
                label={career.is_active ? 'Active' : 'Inactive'}
                color={career.is_active ? 'success' : 'error'}
                sx={{
                  marginBottom: 3, 
                  fontWeight: 600, 
                  padding: '5px 15px',
                  backgroundColor: career.is_active ? '#4caf50' : '#f44336',
                  color: '#fff'
                }}
              />

              {/* Back Button */}
              <Box sx={{ textAlign: 'center' }}>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{
                    padding: '12px 30px',
                    fontSize: '16px',
                    fontWeight: 600,
                    borderRadius: '8px',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
                    '&:hover': { boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.2)' }
                  }}
                  onClick={() => window.history.back()}
                >
                  Back to Careers
                </Button>
              </Box>
            </>
          ) : (
            <Typography variant="body1" sx={{ textAlign: 'center' }}>Loading career details...</Typography>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default ViewCareerDetailPage;
